import { Routes, Route, Navigate } from 'react-router-dom'

import SaleOrderList from 'Presentation/Views/SaleOrder/List/View'
import SaleOrderFormView from 'Presentation/Views/SaleOrder/Form/View'
import { SaleOrderViewContextProvider } from 'Presentation/Views/SaleOrder/Context'
import { SaleOrderImportViewContextProvider } from 'Presentation/Views/SaleOrder/Import/Context'
import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'

const SaleOrderRoutes = () => (
  <Routes>
    <Route element={<ProtectedRoutePermission whitelist={RolePermissionConfigs.sale_order} />}>
      {/* Route: Sale Order List */}
      <Route
        index
        element={
          <SaleOrderViewContextProvider>
            <SaleOrderImportViewContextProvider>
              <SaleOrderList />
            </SaleOrderImportViewContextProvider>
          </SaleOrderViewContextProvider>
        }
      />
      {/* Route: Sale Order List */}

      {/* Route: Create Sale Order */}
      <Route path='create' element={<SaleOrderFormView />} />
      {/* Route: Create Sale Order */}

      {/* Route: Sale Order Detail */}
      <Route path=':id' element={<SaleOrderFormView />} />
      {/* Route: Sale Order Detail */}

      <Route path='*' element={<Navigate to='/home' />} />
    </Route>
  </Routes>
)

export default SaleOrderRoutes
